import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IOutputsCollection } from '../models/outputsCollection';
import { Observable } from 'rxjs';
import {
  OutputsCollectionCreateResult,
  OutputsCollectionResult,
  OutputsCollectionDeleteResult,
  OutputsCollectionProductListResult,
  CollectionAssetPreviewResult,
} from '../models/outputs-collections/outputs-collections-result';
import { FileExtension } from '../models/product-data-filename-conventions/file-extension';
import { PreviewOutputFilenamesRequest } from '../models/outputs-collections/review-output-filenames/preview-output-filenames-request';
import { PreviewOutputFilenamesResponse } from '../models/outputs-collections/review-output-filenames/preview-output-filenames-response';
import { PreviewOutputFilesRequest } from '../models/outputs-collections/preview-output-files/preview-output-files-request';
import { PreviewOutputFilesResponse } from '../models/outputs-collections/preview-output-files/preview-output-files-response';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    Accept: 'application/json',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class OutputsCollectionsService {
  constructor(private http: HttpClient) {}

  createOutputsCollection(data: {
    productIds: string[];
    organizationId: string;
    batchId: string;
    summary: string;
    outputFormulaIds: string[];
    productData: { formats: FileExtension[] };
  }): Observable<OutputsCollectionCreateResult> {
    const url = `${environment.apiBase}/outputs-collections`;
    return this.http.post<OutputsCollectionCreateResult>(url, data, httpOptions);
  }

  listOutputsCollection(): Observable<IOutputsCollection[]> {
    const url = `${environment.apiBase}/outputs-collections`;
    return this.http.get<IOutputsCollection[]>(url);
  }

  getOutputsCollection(id: string): Observable<OutputsCollectionResult> {
    const url = `${environment.apiBase}/outputs-collections/${id}`;
    return this.http.get<OutputsCollectionResult>(url);
  }

  getOutputsCollectionProducts(id: string): Observable<OutputsCollectionProductListResult> {
    const url = `${environment.apiBase}/outputs-collection/${id}/products`;
    return this.http.get<OutputsCollectionProductListResult>(url);
  }

  downloadOutputsCollection(id: string): Observable<void> {
    const url = `${environment.apiBase}/outputs-collection/${id}/download`;
    return this.http.get<void>(url);
  }

  deleteOutputsCollection(id: string): Observable<OutputsCollectionDeleteResult> {
    const url = `${environment.apiBase}/outputs-collection/${id}`;
    return this.http.delete<OutputsCollectionDeleteResult>(url);
  }

  releaseOutputsCollection(id: string): Observable<void> {
    const url = `${environment.apiBase}/outputs-collection/${id}/release`;
    return this.http.post<void>(url, {}, httpOptions);
  }

  unReleaseOutputsCollection(id: string): Observable<void> {
    const url = `${environment.apiBase}/outputs-collection/${id}/release`;
    return this.http.delete<void>(url, httpOptions);
  }

  previewOutputsCollection(data: {
    productIds: string[];
    outputFormats: {
      outputFormatId: string;
      type: string;
    }[];
    productDataFormats: FileExtension[];
  }): Observable<CollectionAssetPreviewResult> {
    const url = `${environment.apiBase}/outputs-collections/preview`;
    return this.http.post<CollectionAssetPreviewResult>(url, data, httpOptions);
  }

  previewOutputFilenames(
    request: PreviewOutputFilenamesRequest,
  ): Observable<PreviewOutputFilenamesResponse> {
    const url = `${environment.apiBase}/outputs-collections/preview-filenames`;
    return this.http.post<PreviewOutputFilenamesResponse>(url, request, httpOptions);
  }

  previewOutputFiles(
    request: PreviewOutputFilesRequest,
  ): Observable<PreviewOutputFilesResponse> {
    const url = `${environment.apiBase}/outputs-collections/preview-files`;
    return this.http.post<PreviewOutputFilesResponse>(url, request, httpOptions);
  }
}
